<mat-dialog-content class="dialog-content">
  <section>
    @if (loading) {
      <mds-loader></mds-loader>
    }
    @if (teamMembers?.length && !loading) {
      <div class="member">
        @for (user of teamMembers; track user) {
          <div class="member__item">
            <div class="member__avatar">
              <mds-avatar
                class="profile-image"
                [altText]="user.display_value"
                [firstName]="user.display_value | getInitials: 'first'"
                [imageSrc]="user.icon"
                [lastName]="user.display_value | getInitials: 'last'"
              ></mds-avatar>
              <div class="member__info">
                @if (user.link) {
                  <a
                    (click)="closeDialog()"
                    [attr.aria-label]="'Go to Profile ' + user.display_value"
                    [routerLink]="'/' + user.link.url"
                    >
                    <h5>
                      {{ user.display_value }}
                      @if (user.rid === userRid) {
                        <span>(You)</span>
                      }
                    </h5>
                  </a>
                } @else {
                  <h5>
                    {{ user.display_value }}
                    @if (user.rid === userRid) {
                      <span>(You)</span>
                    }
                  </h5>
                }
                <div class="member__email">
                  {{ user.email }}
                </div>
              </div>
            </div>
            @if (user.is_admin) {
              <mds-tag [text]="'Admin'" [type]="'off-soft'" [icon]="icons.ADMIN"></mds-tag>
            }
            @if (isEditable && user.rid != userRid) {
              <mds-icon
                (click)="editUsersData(user)"
                [attr.aria-label]="'Edit User Detail ' + user.display_value"
                [height]="20"
                [key]="icons.EDIT"
                [width]="20"
                aria-hidden="true"
                matTooltip="Edit user"
              ></mds-icon>
            }
          </div>
        }
      </div>
    }
    @if (!teamMembers.length && !loading) {
      <app-no-data [data]="emptyData"></app-no-data>
    }
  </section>
</mat-dialog-content>
@if (isEditable) {
  <mat-dialog-actions>
    <app-invite-team
      class="invite-team"
      [data]="invitations[0]"
      [label]="'Invite someone to the team'"
      [reset]="reset | async"
    ></app-invite-team>
    <mds-button
      class="invite-btn"
      [type]="'secondary'"
      (click)="inviteCoWorker()"
      [attr.aria-label]="'Add to team'"
      [disabled]="!(invitations[0].inviteRid || invitations[0].inviteEmail)"
      role="button"
      [icon]="icons.ADD_PERSON"
      [isIconLeft]="true"
      >
      Add to team
    </mds-button>
  </mat-dialog-actions>
}
